// extracted by mini-css-extract-plugin
export default {"paymentSection":"n--z"};